// Cài `gh` CLI qua package manager đã detect. Stream stdio để user thấy progress.
// Throws nếu cài fail hoặc PM trả non-zero.
import { spawnSync } from "node:child_process";
import type { PackageManager } from "./detect-package-manager.js";
import { isNonInteractive } from "./non-interactive-context.js";
import { log } from "./terminal-logger.js";

// Map PM → command + args để cài gh. apt/dnf cần sudo; brew/pacman/winget thì không.
const INSTALL_COMMANDS: Record<PackageManager, { cmd: string; args: string[] }> = {
  brew: { cmd: "brew", args: ["install", "gh"] },
  apt: { cmd: "sudo", args: ["apt-get", "install", "-y", "gh"] },
  dnf: { cmd: "sudo", args: ["dnf", "install", "-y", "gh"] },
  pacman: { cmd: "sudo", args: ["pacman", "-S", "--noconfirm", "github-cli"] },
  winget: { cmd: "winget", args: ["install", "--id", "GitHub.cli", "-e", "--silent"] },
};

export function installGhCliViaPackageManager(pm: PackageManager): void {
  const spec = INSTALL_COMMANDS[pm];
  // ⛔ KHÔNG TREO KHI KHÔNG CÓ NGƯỜI (#293): bảng trên chứa `sudo apt-get` /
  // `sudo dnf` / `sudo pacman` — `sudo` hỏi mật khẩu qua `stdio: "inherit"`, và với
  // stdin đóng nó đợi vô hạn. Đây KHÔNG phải prompt của @inquirer nên `prompt-or-flag`
  // không chặn được; phải gác riêng tại đây, giống `triggerGhCliAuthLogin`.
  //
  // Chốt đặt TRƯỚC `spawnSync` chứ không bọc quanh lỗi của nó: mục đích là tiến trình
  // con KHÔNG được sinh ra lần nào, không phải "sinh ra rồi báo lỗi đẹp".
  if (isNonInteractive()) {
    throw new Error(
      `gh CLI chưa cài, mà cài qua ${pm} có thể cần mật khẩu sudo — không chạy được ở ` +
        `chế độ non-interactive. Chạy \`${spec.cmd} ${spec.args.join(" ")}\` một lần ` +
        "trên máy này rồi gọi lại.",
    );
  }
  log.info(`Đang cài gh CLI qua ${pm}...`);
  const r = spawnSync(spec.cmd, spec.args, { stdio: "inherit" });
  if (r.status !== 0) {
    throw new Error(`Cài gh CLI thất bại qua ${pm} (exit ${r.status}). Cài tay rồi chạy lại.`);
  }
  log.success("Đã cài gh CLI");
}
